import React from 'react';
import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultRoleResource,
    RoleMutationResourceSchema,
    useRoleActions,
} from '../../../../../resource/resources/artifacts/role/roleResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import {
    Form_DisplayComponentBaseView,
} from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { RoleContent } from './RoleContent';

export const RoleEditDialog= ({ onClose, objectId, versionedInId }: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const roleActions = useRoleActions()
    const roleQuery = roleActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateRole = roleActions.useUpdateResource();
    const validation = roleActions.useValidateResource(roleQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: RoleMutationResourceSchema,
        defaultValues: defaultRoleResource,
        submitHandler: async (data) => {
            await updateRole.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: roleQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Role'}
            resourceType={ResourceType.ROLE}
            resourceValidationResult={validation.data}
            metaDataInfo={roleQuery.data}
        >
            <QueryBaseComponent name="Role" query={roleQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <RoleContent form={form} formNames={formNames} readOnly={readOnly} id={roleQuery.data?.id} />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
